const PREFIX_PATH_APPGUI = "/appgui";
const PREFIX_PATH_APPCOMMERCIALE = "/appcommerciale";
const PREFIX_PATH_APPADMIN = "/appadmin";

const RELATIVE_ENDPOINT_LOGIN = '/signin';

const RELATIVE_ENDPOINT_ORGANIZATION_UPLOADLOGO = '/uploadlogo';

const RELATIVE_ENDPOINT_ORGANIZATIONS = '/organizations';
const RELATIVE_ENDPOINT_SERVICES = '/services';
const RELATIVE_ENDPOINT_USER = '/users';

const RELATIVE_ENDPOINT_GUI_ADMIN_ORGANIZATIONS = '/orgs';

//const RENDER3D_BASIC_GALLERY_URL = 'https://workspace.showin3d.com/embed/58bdcfb2c72536d27542b382b06ae04c7817f59f1075fff6555f55b3ec46589e?oi=1&lg=it&si3d_player_version=2.03.665';
const RENDER3D_BASIC_GALLERY_URL = 'https://workspace.showin3d.com/embed/58bdcfb2c72536d27542b382b06ae04c7817f59f1075fff6555f55b3ec46589e?oi=1&lg=it';


//const ENDPOINT_REPOSITORY_THREEJS = 'http://localhost/closetech/threejsobj';
//const ENDPOINT_REPOSITORY_THREEJS = 'http://192.168.1.122/closetech/threejsobj/';
//const ENDPOINT_REPOSITORY_THREEJS = 'https://closetech.demo.mediaus.online/threejsobj/';
const ENDPOINT_REPOSITORY_THREEJS = '/threejsobj/';

const RELATIVE_ENDPOINT_GATEWAY_PROJECT_PDF = '/gateway/projectPdf';
const RELATIVE_ENDPOINT_GATEWAY_POI_S3D_LIST = '/gateway/s3dpoilist';
const RELATIVE_ENDPOINT_GATEWAY_POI_S3D_DETAILS = '/gateway/s3dpoidetails';
const RELATIVE_ENDPOINT_GATEWAY_POI_CHART = '/gateway/poichart';
const RELATIVE_ENDPOINT_GATEWAY_TJS_OBJ_LIST = '/gateway/tjsobjlist';
const RELATIVE_ENDPOINT_GATEWAY_S3D_BASIC_ITEMS_LIST = '/gateway/s3dbasicitemslist';
const RELATIVE_ENDPOINT_GATEWAY_POI_TJS_MAP_CONFIG = '/gateway/tjsmapconfig';
const RELATIVE_ENDPOINT_GATEWAY_POI_TJS_LIST = '/gateway/tjspoilist';
const RELATIVE_ENDPOINT_GATEWAY_POI_DETAILS = '/gateway/poidetails';
const RELATIVE_ENDPOINT_GATEWAY_POI_STATS = '/gateway/poistats';
const RELATIVE_ENDPOINT_GATEWAY_BKG_IMG_LIST= '/gateway/poibkgimglist';
const RELATIVE_ENDPOINT_GATEWAY_SITES_LIST_ALERT= '/gateway/siteslistalert';
const RELATIVE_ENDPOINT_GATEWAY_MAPS_LIST_ALERT= '/gateway/mapslistalert';
const RELATIVE_ENDPOINT_GATEWAY_POI_LIST_ALERT= '/gateway/poilistalert';
const RELATIVE_ENDPOINT_GATEWAY_RENDER_IMAGE_POI_LIST = '/gateway/renderimagepoilist';



const EVENT_CHANGE_LOCALE = "changeLocale"; 
const EVENT_DO_LOAD_ORG_DETAILS= "DO_LOAD_PRJ_DETAILS";
const EVENT_DO_LOAD_PROJECT_LIST= "DO_LOAD_PROJECT_LIST";
const EVENT_DO_LOAD_PRJ_DETAILS= "DO_LOAD_PRJ_DETAILS";
const EVENT_DO_INIT_CART= "DO_INIT_CART";
const EVENT_DO_INIT_WORKFLOW = "EVENT_DO_INIT_WORKFLOW";
const EVENT_DO_INIT_PRICE_QUOTATION = "EVENT_DO_INIT_PRICE_QUOTATION";
const EVENT_DO_INIT_DATASHEET = "EVENT_DO_INIT_DATASHEET";
const EVENT_DO_CHANGE_PRJ_STATUS = "DO_CHANGE_PRJ_STATUS";
const EVENT_MAP_DETAIL_LOADED = "MAP_DETAIL_LOADED";

const EVENT_DO_LOAD_SITE_LIST = "DO_LOAD_SITE_LIST";
const EVENT_DO_LOAD_MAP_LIST= "DO_LOAD_MAP_LIST";

const EVENT_DIALOG_RENDER_3D_OPEN = "DIALOG_RENDER_3D_OPEN";
const EVENT_DIALOG_RENDER_3D_CLOSE = "DIALOG_RENDER_3D_CLOSE"; 
const EVENT_DIALOG_STATS_OPEN = "DIALOG_STATS_OPEN";
const EVENT_DIALOG_STATS_CLOSE = "DIALOG_STATS_CLOSE"; 

const PRJ_STATUS_CREATED= 'created';
const PRJ_STATUS_IN_PROGRESS= 'in_progress';
const PRJ_STATUS_DONE= 'done';

const THREEJS_FLOOR_GRID_SIZE = 10;
const THREEJS_FLOOR_GRID_DIVISION = 20;



var gatewayHostname = location.host;
var awsHostnameAdminGui = 'https://5j5hvtg4h4.execute-api.eu-west-1.amazonaws.com/dev/v1';
var awsHostnameAppCommerciale = 'https://i0oy7ioxjk.execute-api.eu-west-1.amazonaws.com/Dev';
var awsHostnameLogin = 'https://swvem2v9tg.execute-api.eu-west-1.amazonaws.com/dev';
var awsHostnameUploadLogo = 'https://kki2npa67i.execute-api.eu-west-1.amazonaws.com/v1/organizations';

if(process.env.NODE_ENV == 'development')
{
    //gatewayHostname = "https://closetech.demo.mediaus.online";
    gatewayHostname = "https://www.closetech.it";
    awsHostnameAdminGui = 'https://5j5hvtg4h4.execute-api.eu-west-1.amazonaws.com/dev/v1';
    awsHostnameAppCommerciale = 'https://i0oy7ioxjk.execute-api.eu-west-1.amazonaws.com/Dev';
    awsHostnameLogin = 'https://swvem2v9tg.execute-api.eu-west-1.amazonaws.com/dev';
    awsHostnameUploadLogo = 'https://kki2npa67i.execute-api.eu-west-1.amazonaws.com/v1/organizations';
} 
else 
{
    gatewayHostname = location.protocol + '//' + location.host;
    awsHostnameAdminGui = 'https://5j5hvtg4h4.execute-api.eu-west-1.amazonaws.com/dev/v1';
    awsHostnameAppCommerciale = 'https://i0oy7ioxjk.execute-api.eu-west-1.amazonaws.com/Dev';
    awsHostnameLogin = 'https://swvem2v9tg.execute-api.eu-west-1.amazonaws.com/dev';
    awsHostnameUploadLogo = 'https://kki2npa67i.execute-api.eu-west-1.amazonaws.com/v1/organizations';
} 

export default {
    PREFIX_PATH_APPGUI: PREFIX_PATH_APPGUI,
    PREFIX_PATH_APPCOMMERCIALE: PREFIX_PATH_APPCOMMERCIALE,
    PREFIX_PATH_APPADMIN: PREFIX_PATH_APPADMIN,

    ENDPOINT_LOGIN: awsHostnameLogin + RELATIVE_ENDPOINT_LOGIN,
    ENDPOINT_ORGANIZATION_UPLOADLOGO: awsHostnameUploadLogo + RELATIVE_ENDPOINT_ORGANIZATION_UPLOADLOGO,

    ENDPOINT_ORGANIZATIONS: awsHostnameAppCommerciale + RELATIVE_ENDPOINT_ORGANIZATIONS,
    ENDPOINT_SERVICES: awsHostnameAppCommerciale + RELATIVE_ENDPOINT_SERVICES,
    ENDPOINT_USER: awsHostnameAppCommerciale + RELATIVE_ENDPOINT_USER,
    
    ENDPOINT_GUI_ADMIN_ORGANIZATIONS: awsHostnameAdminGui + RELATIVE_ENDPOINT_GUI_ADMIN_ORGANIZATIONS,

    ENDPOINT_REPOSITORY_THREEJS:ENDPOINT_REPOSITORY_THREEJS,
    RENDER3D_BASIC_GALLERY_URL: RENDER3D_BASIC_GALLERY_URL,

    ENDPOINT_GATEWAY_PROJECT_PDF: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_PROJECT_PDF,
    ENDPOINT_GATEWAY_POI_S3D_LIST: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_POI_S3D_LIST,
    ENDPOINT_GATEWAY_POI_S3D_DETAILS: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_POI_S3D_DETAILS,
    ENDPOINT_GATEWAY_POI_CHART: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_POI_CHART,
    ENDPOINT_GATEWAY_TJS_OBJ_LIST: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_TJS_OBJ_LIST,
    ENDPOINT_GATEWAY_S3D_BASIC_ITEMS_LIS: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_S3D_BASIC_ITEMS_LIST,
    ENDPOINT_GATEWAY_POI_TJS_MAP_CONFIG: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_POI_TJS_MAP_CONFIG,
    ENDPOINT_GATEWAY_POI_TJS_LIST: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_POI_TJS_LIST,
    ENDPOINT_GATEWAY_POI_DETAILS: gatewayHostname +RELATIVE_ENDPOINT_GATEWAY_POI_DETAILS,
    ENDPOINT_GATEWAY_POI_STATS: gatewayHostname +RELATIVE_ENDPOINT_GATEWAY_POI_STATS,
    ENDPOINT_GATEWAY_BKG_IMG_LIST: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_BKG_IMG_LIST,
    ENDPOINT_GATEWAY_SITES_LIST_ALERT: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_SITES_LIST_ALERT,
    ENDPOINT_GATEWAY_MAPS_LIST_ALERT: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_MAPS_LIST_ALERT,
    ENDPOINT_GATEWAY_POI_LIST_ALERT: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_POI_LIST_ALERT,
    ENDPOINT_GATEWAY_RENDER_IMAGE_POI_LIST: gatewayHostname + RELATIVE_ENDPOINT_GATEWAY_RENDER_IMAGE_POI_LIST,

    EVENT_CHANGE_LOCALE: EVENT_CHANGE_LOCALE,
    EVENT_DO_LOAD_ORG_DETAILS: EVENT_DO_LOAD_ORG_DETAILS,
    EVENT_DO_LOAD_PROJECT_LIST: EVENT_DO_LOAD_PROJECT_LIST,
    EVENT_DO_LOAD_PRJ_DETAILS:EVENT_DO_LOAD_PRJ_DETAILS,
    EVENT_DO_INIT_CART: EVENT_DO_INIT_CART,
    EVENT_DO_INIT_WORKFLOW: EVENT_DO_INIT_WORKFLOW,
    EVENT_DO_INIT_PRICE_QUOTATION: EVENT_DO_INIT_PRICE_QUOTATION,
    EVENT_DO_INIT_DATASHEET: EVENT_DO_INIT_DATASHEET, 
    EVENT_DO_CHANGE_PRJ_STATUS: EVENT_DO_CHANGE_PRJ_STATUS,
    EVENT_MAP_DETAIL_LOADED: EVENT_MAP_DETAIL_LOADED,
    EVENT_DO_LOAD_SITE_LIST: EVENT_DO_LOAD_SITE_LIST,
    EVENT_DO_LOAD_MAP_LIST: EVENT_DO_LOAD_MAP_LIST,
    EVENT_DIALOG_RENDER_3D_OPEN:EVENT_DIALOG_RENDER_3D_OPEN, 
    EVENT_DIALOG_RENDER_3D_CLOSE: EVENT_DIALOG_RENDER_3D_CLOSE,
    EVENT_DIALOG_STATS_OPEN: EVENT_DIALOG_STATS_OPEN,
    EVENT_DIALOG_STATS_CLOSE: EVENT_DIALOG_STATS_CLOSE,
    
    PRJ_STATUS_CREATED: PRJ_STATUS_CREATED,
    PRJ_STATUS_IN_PROGRESS: PRJ_STATUS_IN_PROGRESS,
    PRJ_STATUS_DONE: PRJ_STATUS_DONE,

    THREEJS_FLOOR_GRID_SIZE: THREEJS_FLOOR_GRID_SIZE,
    THREEJS_FLOOR_GRID_DIVISION: THREEJS_FLOOR_GRID_DIVISION

}   